export const LOAD_ELEMENTS_SCRIPT_REQUEST = 'LOAD_ELEMENTS_SCRIPT_REQUEST'
export const STORE_STYTCH_ELEMENTS = 'STORE_STYTCH_ELEMENTS'
export const LOAD_ELEMENTS_SCRIPT_SUCCESS = 'LOAD_ELEMENTS_SCRIPT_SUCCESS'
export const LOAD_ELEMENTS_SCRIPT_FAILURE = 'LOAD_ELEMENTS_SCRIPT_FAILURE'

export const RETRIEVE_REPORTING_URI_REQUEST = 'RETRIEVE_REPORTING_URI_REQUEST'
export const RETRIEVE_REPORTING_URI_SUCCESS = 'RETRIEVE_REPORTING_URI_SUCCESS'
export const RETRIEVE_REPORTING_URI_FAILURE = 'RETRIEVE_REPORTING_URI_FAILURE'

export const BACK_TO_DASHBOARD_BUTTON_HEIGHT = 36

export const STYTCH_ACTIONS = {
  EDIT: 'edit',
  VIEW: 'view',
  CREATE_REPORT: 'createReport',
  VIEW_REPORT: 'viewReport',
  EDIT_REPORT: 'editReport',
  CREATE_DASHBOARD: 'createDashboard',
  VIEW_DASHBOARD: 'viewDashboard',
  GET_PARAMETERS: 'getParameters',
  EDIT_DASHBOARD: 'editDashboard',
  VIEW_LANDING_DASHBOARD: 'viewLandingPage',
  C1_DEFAULT_DASHBOARD: 'viewC1DefaultDashboard',
  CLEAR: 'clear',
  PROMPT_SAVE: 'promptSave',
  ASSET_BROWSER: 'assetBrowser',
  DATA_LIBRARY: 'dataLibrary',
  SETTINGS: 'settings',
  SHARING_GROUP_ADMIN: 'sharingGroupsAdmin',
  STAY: 'stay',
  LEAVE: 'leave',
} as const

export const ACTIONS_TO_STYTCH_ROUTES = {
  viewReport: '/report/view/',
  createReport: '/report/edit/new',
  editReport: '/report/edit/',
  viewDashboard: '/dashboard/view/',
  createDashboard: '/dashboard/edit/new',
  editDashboard: '/dashboard/edit/',
  settings: '/settings',
  dataLibrary: '/dataLibrary',
  sharingGroups: '/sharingGroups',
}

export const ASSET_TYPE = {
  DB1: 'compositereport',
  compositereport: 'DB1',
  RP1: 'report',
  report: 'RP1',
}

export const NAVIGATION_IGNORED_ACTIONS = [
  STYTCH_ACTIONS.CLEAR,
  STYTCH_ACTIONS.PROMPT_SAVE,
]
